import type { FC } from 'react';

import { Box, Image, Text } from '@opendoor/bricks-next';
import { Currency } from 'shared/components/Currency';

type PropertyCardProps = {
  beds?: number | null;
  baths?: number | null;
  city?: string | null;
  address?: string | null;
  photoUrl?: string | null;
  price?: number | null;
  sqft?: number | null;
};

export const PropertyCard: FC<PropertyCardProps> = ({
  address,
  beds,
  baths,
  city,
  photoUrl,
  price,
  sqft,
}) => {
  return (
    <Box flexDirection="column" width="100%">
      <Box width="100%" mb="$8x" borderRadius="$8x" overflow="hidden">
        {!!photoUrl && (
          <Image
            alt="Main view of property"
            borderRadius="$8x"
            source={{ uri: photoUrl }}
            resizeMode="cover"
            aspectRatio={16 / 9}
          />
        )}
      </Box>
      <Box flexDirection="row" alignItems="center" justifyContent="space-between" mb="$4x">
        <Box flexDirection="row" alignItems="baseline">
          {price && (
            <Currency value={price} typography="$labelXlarge" tag="span" mr="$2x" inDollars />
          )}
        </Box>
      </Box>
      <Box flexDirection="row" alignItems="baseline" width="100%">
        <Text tag="span" typography="$bodySmall" color="$contentTertiary">
          {beds && `${beds} bds`}
        </Text>
        {!!baths && (
          <>
            <Text tag="span" typography="$bodySmall" color="$contentStateInactiveSecondary">
              {' • '}
            </Text>
            <Text tag="span" typography="$bodySmall" color="$contentTertiary">
              {baths} ba
            </Text>
          </>
        )}
        {!!sqft && (
          <>
            <Text tag="span" typography="$bodySmall" color="$contentStateInactiveSecondary">
              {' • '}
            </Text>
            <Text tag="span" typography="$bodySmall" color="$contentTertiary">
              {sqft.toLocaleString()} sqft
            </Text>
          </>
        )}
      </Box>
      <Box flexDirection="row" alignItems="baseline">
        {!!address && (
          <Text tag="span" mr="$1x" typography="$bodySmall" color="$contentTertiary">
            {address}
            {!!city && ', '}
          </Text>
        )}
        {!!city && (
          <Text tag="span" mr="$1x" typography="$bodySmall" color="$contentTertiary">
            {city}
          </Text>
        )}
      </Box>
    </Box>
  );
};
